module.exports = __webpack_public_path__ + "staticcomp/img/content_1副本.548f172.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/5/content_1副本.jpg
// module id = jx+i
// module chunks = 39